import { createFileRoute, redirect } from "@tanstack/react-router"

// The page this served was renamed to LOIS usage. The old path stays because
// it is the one in everybody's bookmarks and in every link sent before the
// rename; it forwards rather than 404s.
export const Route = createFileRoute("/core/analytics/ai-usage")({
  beforeLoad: () => {
    throw redirect({ to: "/core/analytics/lois-usage", replace: true })
  }
})
